import { useContext, useState } from 'react'

import { CartContext } from '@lib/cart'
import { ProductVariantSelectionContext } from '@lib/product-variant-selection-context'
import { productVariantIdAttributeKey } from '@lib/shopify/cart'
import { StringsContext } from '@lib/strings-context'

import Alert from '@components/alert'
import Button from '@components/buttons/button'
import ComplexPortableText from '@components/portable-text/complex'
import ProductAdd from './product-add'
import ProductCounter from './product-counter'

/**
 * Component that shows actions for basic products.
 */
const ProductActions = () => {
  const strings = useContext(StringsContext)
  const { addItemsToCart } = useContext(CartContext)
  const { selectedVariant } = useContext(ProductVariantSelectionContext)

  const [quantity, setQuantity] = useState(1)
  const [isAddToCartError, setIsAddToCartError] = useState(false)

  const handleAddToCart = async () => {
    if (!selectedVariant) {
      return
    }

    setIsAddToCartError(false)

    const feeLineItems =
      selectedVariant.fees?.map((fee) => ({
        id: fee.variantID,
        quantity,
        attributes: [
          {
            key: `_${productVariantIdAttributeKey}`,
            value: selectedVariant.id.toString(),
          },
        ],
      })) ?? []

    const isSuccessful = await addItemsToCart(async () => {
      return [
        {
          id: selectedVariant.id,
          quantity,
        },
        ...feeLineItems,
      ]
    })

    setIsAddToCartError(!isSuccessful)
  }

  if (selectedVariant && !selectedVariant.inStock) {
    return (
      <Button
        variant="primary"
        color="red"
        icon="Cart"
        className="min-w-[240px]"
        disabled
      >
        {strings.productOutOfStock}
      </Button>
    )
  }

  return (
    <div className="flex flex-col gap-y-4 items-baseline w-full text-center">
      <ProductCounter max={10} onUpdate={setQuantity} />

      <ProductAdd
        variant="primary"
        color="red"
        icon="Cart"
        className="min-w-[240px]"
        onClick={handleAddToCart}
        disabled={!selectedVariant}
      >
        {strings.buttonAddToCart}
      </ProductAdd>

      {isAddToCartError && (
        <Alert error>
          <ComplexPortableText
            content={strings.cartAddToCartErrorMessage}
            className="rc rc-error"
          />
        </Alert>
      )}
    </div>
  )
}

export default ProductActions
